module.exports = __webpack_public_path__ + "img/annualForecastGreen.c90c7ba7.png";